export default __webpack_public_path__ + "static/media/background-edge.b761449b.gif";